module.exports = require('./abstract-annual-report').extend({
    beforeModel: function(transition) {
        this._super(transition)
        this.replaceWith('annual_reports')
    }
})
